// 261010 P9Q — một dòng ở đầu mục bước: AI đang chấm/sửa (biểu tượng xoay, trạng thái chờ) hoặc «AI còn N góp ý» (danh sách chỉ-đọc). Không ô lý do, không nút chấm/sửa thủ công. Luật: workflowQualityWaitPolicy.ts.
import React from 'react';
import type { WorkflowStatus, WorkflowStepKey } from '../../types/filmWorkflow';
import { qualityAdvisoryOf, qualityWaitOf, videosText } from './workflowQualityWaitPolicy';
import WfIcon from './WfIcon';

/** `hideWait`: nút chính ở đầu trang đã hiện trạng thái chạy/chờ ⇒ không lặp lại «AI đang chấm…» ở thân bước. */
const WorkflowQualityNote: React.FC<{ status: WorkflowStatus; step: WorkflowStepKey; hideWait?: boolean }> = ({ status, step, hideWait }) => {
  const wait = qualityWaitOf(status, step);
  if (wait.waiting) {
    if (hideWait) return null;
    return <p className="wf-qwait" role="status" data-testid="wf-qwait"><span className="wf-si doing"><WfIcon name="loading" /></span>{wait.text}</p>;
  }
  const adv = qualityAdvisoryOf(status, step);
  if (!adv) return null;
  return (
    <details className="wf-qadv" data-testid="wf-qadv">
      <summary data-testid="wf-qadv-sum">AI còn {adv.count} góp ý</summary>
      <ul>
        {adv.lines.map((l) => {
          const v = videosText(l.videos);
          return (
            <li key={l.id}>
              {l.criterion ? <b>{l.criterion}</b> : null}{l.criterion && (v || l.text) ? ' · ' : ''}
              {v ? <span className="v">{v}</span> : null}{v && l.text ? ' · ' : ''}{l.text}
            </li>
          );
        })}
        {adv.truncated ? <li className="muted">…và {adv.count - adv.lines.length} góp ý nữa.</li> : null}
      </ul>
    </details>
  );
};

export default WorkflowQualityNote;
